import PropTypes from 'prop-types';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateAccountForm from '../components/CreateAccountForm';
import decodeURIComponentSafe from '../helpers/decodeURIComponentSafe';
import { routerLocationShape } from '../helpers/propTypeShapes';
import '../style/createaccount.css';
import '../style/login.css';
import '../style/resetpassword.css';

export default class CreatePassword extends Component {
  constructor(props) {
    super(props);
    const queryObject = this.parseQuery(this.props.location.search);
    this.state = {
      email: queryObject.email,
      hash: queryObject.hash,
      location: queryObject.location,
      name: '',
      password: '',
      passwordConfirmation: '',
      error: 'hidden',
      createAccountValidationState: 'invalid',
    };

    this.getAccountInfo = this.getAccountInfo.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    // this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
    this.handleCreateAccountSubmit = this.handleCreateAccountSubmit.bind(this);
  }

  componentDidMount() {
    this.props.showHeader(false);
    this.getAccountInfo();
  }

  componentWillUnmount() {
    this.props.showHeader(true);
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value }, () => {
      this.checkFormValidity();
    });
  }

  handleLogin() {
    const params = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password,
      }),
    };

    fetch(`${this.props.APIBaseURL}/auth/login`, params)
      .then((results) => results.json())
      .then((data) => this.props.appLogin(data, true))
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('auth/login API call failed. ', error);
      });
  }

  handleNameChange(event) {
    this.setState({ name: event.target.value }, () => {
      this.checkFormValidity();
    });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value }, () => {
      this.checkFormValidity();
    });
  }

  handlePasswordConfirmationChange(event) {
    this.setState({ passwordConfirmation: event.target.value }, () => {
      this.checkFormValidity();
    });
  }

  handleCreateAccountSubmit(event) {
    const params = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
      },
      body: JSON.stringify({
        email: this.state.email,
        hash: this.state.hash,
        location: this.state.location,
        name: this.state.name,
        password: this.state.password,
      }),
    };

    event.preventDefault();
    fetch(`${this.props.APIBaseURL}/invites/accept`, params)
      .then((response) => {
        function chainError(error) {
          throw new Error(error);
        }

        if (response.status === 400) {
          this.props.trackEvent('400', {
            source: 'handleRequestSubmit',
          });
          response
            .text()
            .then((errorMessage) => {
              toast.error(errorMessage, { autoClose: 30000 });
              chainError(errorMessage);
              this.setState({ error: '' });
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error('Account creation API call failed. ', error);
            });
        } else if (response.status === 404) {
          this.setState({ error: '' });
        } else if (response.status === 409) {
          toast.error('This account has already been created.');
          this.setState({ error: '' });
        } else {
          this.handleLogin();
        }
        return null;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('invites/accept API call failed. ', error);
      });
  }

  getAccountInfo() {
    const { email, hash } = this.state;
    if (!email || !hash) {
      return;
    }

    const params = {
      headers: {
        authorization: sessionStorage.getItem('authToken'),
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
      },
    };

    fetch(`${this.props.APIBaseURL}/invites/search/by-email?hash=${hash}&email=${encodeURIComponent(email)}`, params)
      .then((response) => {
        if (response.status === 404) {
          toast.error('This account has already been created.');
          this.setState({ error: '' });
          return undefined;
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.name) {
          this.setState(
            {
              name: data.name,
            },
            () => {
              document.getElementById('userName').value = data.name;
              this.checkFormValidity();
            }
          );
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }

  checkFormValidity() {
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
    const isValidEmail = re.test(this.state.email);

    if (this.state.email && this.state.hash) {
      // && this.state.location
      if (
        isValidEmail &&
        this.state.hash.length > 0 &&
        // && this.state.location.length > 0
        this.state.name.length > 0 &&
        this.state.password.length > 0 &&
        this.state.password === this.state.passwordConfirmation
      ) {
        this.setState({ createAccountValidationState: 'valid' });
      } else {
        this.setState({ createAccountValidationState: 'invalid' });
      }
    } else {
      this.setState({ createAccountValidationState: 'invalid' });
    }
  }

  parseQuery(queryString) {
    const query = {};
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i += 1) {
      const pair = pairs[i].split('=');
      query[decodeURIComponentSafe(pair[0])] = decodeURIComponentSafe(pair[1] || '');
    }
    return query;
  }

  render() {
    let createAccountDisabled = null;

    if (this.state.createAccountValidationState === 'invalid') {
      createAccountDisabled = 'disabled';
    }
    return (
      <div className="login-content content-container create-account-content">
        <div className="login-left">
          <div className="login-block-type">
            Harness the power
            <br />
            of live video
          </div>
        </div>
        <div className="login-right">
          <div className="login-right-content">
            <div className="login-logo-container">
              <img className="login-logo" src="/sl_logo_name_v2_light.png" alt="Socialive Logo" />
            </div>
            <CreateAccountForm
              createAccountDisabled={createAccountDisabled}
              createAccountValidationState={this.state.createAccountValidationState}
              email={this.state.email}
              handleCreateAccountSubmit={this.handleCreateAccountSubmit}
              handleNameChange={this.handleNameChange}
              handlePasswordChange={this.handlePasswordChange}
              handlePasswordConfirmationChange={this.handlePasswordConfirmationChange}
            />
            <div className={`error-bloc ${this.state.error}`}>
              <span className="error">
                Something went wrong. If you have already created an account, you can log in
                <Link to="/login">here.</Link>
              </span>
            </div>
            <div className="copyright">
              <span className="byline">
                Copyright © 2007 -{this.props.currentYear} Socialive. All rights reserved. |{' '}
              </span>
              <a
                href="https://www.socialive.us/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="byline"
              >
                Privacy
              </a>
              <span className="byline"> | </span>
              <a
                href="https://www.socialive.us/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
                className="byline"
              >
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CreatePassword.propTypes = {
  APIBaseURL: PropTypes.string.isRequired,
  appLogin: PropTypes.func.isRequired,
  currentYear: PropTypes.number.isRequired,
  location: routerLocationShape.isRequired,
  showHeader: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};
